<template>
	<v-container>
		<v-alert v-if="alertCriticas() && editar" color="error" :value="true" class="mb-3 mt-0">
			Instruções
			<ul>
				<li class="mb-1 mt-3">
					Os campos que contém inconsistências estão marcados em vermelho, com um texto detalhando a razão da reprovação.
				</li>
			</ul>
		</v-alert>
		<v-card class="elevation-1">
			<v-toolbar flat dark color="primary">
				<v-toolbar-title>Membros da Família</v-toolbar-title>
				<v-spacer />
				<v-btn
					v-if="$vuetify.breakpoint.mdAndUp && editar"
					@click.prevent="modalOpen = true; $refs.dialogAddFamiliar.open()"
				>
					Adicionar familiar
				</v-btn>
			</v-toolbar>

			<v-list two-line class="py-0">
				<template v-if="familiares.length === 0">
					<v-list-tile>
						<v-list-tile-content class="pl-2">Nenhum familiar cadastrado</v-list-tile-content>
					</v-list-tile>
				</template>
				<template v-for="(f, index) in familiares">
					<v-list-tile :key="index" @click.prevent="showEditFamiliarDialog(index)">
						<v-list-tile-avatar class="pl-1">
							<v-icon v-if="checkCriticas(f.id) && editar" color="error" large>person</v-icon>
							<v-icon v-else color="primary" large>person</v-icon>
						</v-list-tile-avatar>
						<v-list-tile-content>
							<v-list-tile-title>{{ f.nome }}</v-list-tile-title>
							<v-list-tile-sub-title v-if="$vuetify.breakpoint.mdAndUp">
								<v-chip small class="ml-0">CPF: {{ getMaskedCPF(f.cpf) }}</v-chip>
								<v-chip small>Parentesco: {{ f.parentesco.descricao }}</v-chip>
							</v-list-tile-sub-title>
						</v-list-tile-content>
						<v-btn v-if="checkCriticas(f.id) && editar" icon round dark color="error">
							<v-icon v-if="editar">edit</v-icon>
							<v-icon v-else>visibility</v-icon>
						</v-btn>
						<v-btn v-else icon round dark :color="editar ? 'primary' : '#ddd'">
							<v-icon v-if="editar">edit</v-icon>
							<v-icon v-else>visibility</v-icon>
						</v-btn>
					</v-list-tile>
					<v-divider :key="`divider${index}`" />
				</template>
			</v-list>
		</v-card>

		<v-dialog-factory ref="dialogAddFamiliar">
			<v-familiar v-if="modalOpen" :cpfs="cpfs" @close="close(); modalOpen = false" />
		</v-dialog-factory>

		<v-dialog-factory
			v-for="(f, index) in familiares"
			:key="f.cpf"
			:ref="`dialogEditFamiliar${index}`"
		>
			<v-familiar :cpfs="cpfs" :familiar="f" @close="close(index)" />
		</v-dialog-factory>

		<v-btn
			v-show="$vuetify.breakpoint.smAndDown"
			:disabled="!editar"
			dark
			fab
			fixed
			bottom
			right
			color="pink"
			class="b-10"
			@click.prevent="modalOpen = true ; $refs.dialogAddFamiliar.open()"
		>
			<v-icon>person_add</v-icon>
		</v-btn>

		<v-loading :show="loading" message="Processando requisição" />
	</v-container>
</template>

<script>
	import VDialogFactory from '@/components/dialogFactory';
	import VLoading from '@/components/loading';
	import VFamiliar from './familiar';
	import api from '@/services/api';
	import { maskText } from 'vuetify/lib/util/mask';

	export default {
		components: { VDialogFactory, VFamiliar, VLoading },

		data() {
			return {
				familiares: [],
				loading: false,
				editar: null,
				criticas: [],
				modalOpen: false
			};
		},

		computed: {
			cpfs() {
				if (this.familiares) {
					return this.familiares.map(f => f.cpf);
				}

				return [];
			}
		},

		async created() {
			this.atualizarLista();

			let editar = await api.fetchStatus();

			this.criticas = editar.data.criticas;

			this.editar = editar.data.operacoes.editar;
		},

		methods: {
			getMaskedCPF(value) {
				return maskText(value, '###.###.###-##', false);
			},

			showEditFamiliarDialog(index) {
				this.$refs[`dialogEditFamiliar${index}`][0].open();
			},

			alertCriticas() {
				let keys = Object.keys(this.criticas);
				for (let i = 0; i < keys.length; i++) {
					if (keys[i].includes('membroFamilia')) {
						return true;
					}
				} return false;
			},

			checkCriticas(id) {
				let keys = Object.keys(this.criticas);
				for (let i = 0; i < keys.length; i++) {
					if (keys[i].includes(`membroFamilia.${id}.`) && !(keys[i].includes('.membroFamilia.13.pessoaAnexo.'))) {
						return true;
					}
				} return false;
			},

			async atualizarLista() {
				try {
					this.loading = true;

					let { data }  = await api.fetchMembrosFamilia();

					if (data) {
						this.familiares = data;

						// Essa função está afetando a performance da requisição
						this.familiares.forEach(f => {
							f.cpf = f.cpf && f.cpf.toString().padStart(11, 0);
						});
					}
				} catch ({ data: { message } }) {
					if (message) {
						this.$store.$emit('show-message', { message, timeout: 5000, color: 'danger' });
					}
				} finally {
					this.loading = false;
				}
			},

			close(index) {
				this.atualizarLista();

				if (index !== null && index !== undefined) {
					this.$refs[`dialogEditFamiliar${index}`][0].close();
				} else {
					this.$refs['dialogAddFamiliar'].close();
				}
			}
		}
	};
</script>